import styled from "styled-components/macro"
import { useStore } from "@state/store"
import { useEffect } from "react"
import TextButton from "@common/ui/TextButton"

import { useProjectDataStore } from "@state/projectDataStore"

const FloorplanImage = ({ unit }) => {
  const { imageOverlay, contentControls, syncState } = useStore((s) => ({
    syncState: s.syncState,
    imageOverlay: s.imageOverlay,
    contentControls: s.contentControls,
  }))
  const brandingData = useProjectDataStore((s) => s.brandingData)

  const typeID = unit?.[0]?.unitType
  const name = unit?.[0]?.id
  const src = PLAN_OVERRIDE[name] ?? `assets/floorPlanMedia/${typeID}-info.svg`
  const fallbackSrc = `assets/floorPlanMedia/${typeID}.svg`
  const logoSrc = brandingData?.logos?.darkColourLogo?.url

  console.log(src)

  const planAvailable = true

  useEffect(() => {
    if (imageOverlay) {
      setTimeout(() => {
        syncState({
          imageOverlay: false,
        })
      }, 500)
    }
  }, [contentControls])

  return (
    <Wrapper>
      {unit && planAvailable ? (
        <Floorplan
          src={src}
          alt={unit[0]?.floorplan}
          onError={(e) => {
            if (!e.currentTarget.src.endsWith(fallbackSrc)) {
              e.currentTarget.src = fallbackSrc
            }
          }}
        />
      ) : (
        <img src={logoSrc} className="logo-fallback" />
      )}
      {planAvailable && (
        <TextButton
          className="imageOverlayToggle"
          variant="fill"
          icon={
            imageOverlay ? (
              <img
                src="assets/icons/compress.png"
                alt=""
                style={{ filter: "invert(100%)" }}
              />
            ) : (
              <img
                src="assets/icons/enlarge.png"
                alt=""
                style={{ filter: "invert(100%)" }}
              />
            )
          }
          onClick={() => syncState({ imageOverlay: !imageOverlay })}
        />
      )}
    </Wrapper>
  )
}

export default FloorplanImage

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;

  .logo-fallback {
    position: absolute;
    inset: 25%;
    width: 50%;
    height: 50%;
    object-fit: contain;
    opacity: 0.3;
  }
  .floorplan {
    mix-blend-mode: multiply !important;
  }
`

const Floorplan = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 5rem;
  margin: auto;
  mix-blend-mode: multiply;
`
export const PLAN_OVERRIDE = {
  "635": "assets/floorPlanMedia/33532-info-end.svg",
  "638": "assets/floorPlanMedia/43619-info-end.svg",
  "639": "assets/floorPlanMedia/43612-info-S44.svg",
  "640": "assets/floorPlanMedia/43612-info-S45.svg",
  "636": "assets/floorPlanMedia/43619-info-end-2.svg",
  "659": "assets/floorPlanMedia/43603-info-end.svg",
  "667": "assets/floorPlanMedia/43603-info-end-2.svg",
  "672": "assets/floorPlanMedia/43603-info-S54.svg",
}
